import { useDispatch, useSelector } from 'react-redux';
import { selectIsPlacementChangeOpened } from './store/selectors';
import { useAssignmentFromDetails } from '../CompensationChange/useAssignmentFromDetails';
import { selectIsEafCreating } from '../../../employeeActionsForm/store/selectors';
import React, { useCallback } from 'react';
import { setOpenPlacementChange, updatePlacementId, updateSubassignmentPlacementId } from './store/actions';
import { WorkspaceSidebar } from '../../../../shared/components/workspaces/WorkspaceSidebar/WorkspaceSidebar';
import { Box } from '@material-ui/core';
import { PlacementChangeForm } from './PlacementChangeForm';

export const PlacementChange = () => {
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsPlacementChangeOpened);

    const { assignment, subassignment } = useAssignmentFromDetails();
    const isLoading = useSelector(selectIsEafCreating);
    const onClose = useCallback(() => {
        dispatch(setOpenPlacementChange(false));
    }, [dispatch]);

    const handleSubmit = useCallback(values => {
        if (!subassignment) {
            dispatch(updatePlacementId.init({
                entityId: assignment.id,
                placementId: values.placementId,
            }));
        } else {
            dispatch(updateSubassignmentPlacementId.init({
                entityId: subassignment.id,
                placementId: values.placementId,
            }));
        }
    }, [dispatch, assignment.id, subassignment]);

    return (
        <WorkspaceSidebar
            title="Placement ID change"
            isOpened={isOpen}
            onClose={onClose}
        >
            <Box m={3}>
                <PlacementChangeForm
                    isLoading={isLoading}
                    onSubmit={handleSubmit}
                    onCancel={onClose}
                    aviontePlacementId={subassignment?.avionte_placement_id ?? assignment?.avionte_placement_id}
                />
            </Box>
        </WorkspaceSidebar>
    );
};
